import { createContext } from 'react';
// @ts-ignore
import { LogLevels } from 'c9-js-log-client/dist/log-level-enum';
import { AxiosRequestConfig } from 'axios';

export interface SiteConfig {
    environment: string;
    env: string;
    preview: boolean;
    logLevel: LogLevels | undefined;
    siteType: string;
}

export interface EndpointConfig {
    wso2host: string;
    apiAwsBase: string;
    apiAwsHost: string;
    apiGatewayBase: string;
    logger: string;
    cdnBase: string;
    apiHippoHost: string;
    contentDocuments: string;
    htmlContent: string;
    resourceBundle: string;
}

export interface User {
    getActiveUser: () => ActiveUser;
    getLogonUser: () => LogonUser;
    isLoggedOn: boolean;
}

export interface ActiveUser {
    name: string;
    primaryEmail: string;
    primaryPhone: string;
    roleList: string[];
    customerIdList: string[];
}

export interface LogonUser {
    name: string;
    activeUser: boolean;
}

export interface TopConfig {
    siteConfig: SiteConfig;
    environment: string;
    endpointConfig: EndpointConfig;
    appBasePath: string;
    contentBase: string;
    uploadClientId: string;
    appName: string;
    highwayUrl: string;
    logLevel: LogLevels | undefined;
    user: User;
    features?: Features;
    services: {
        stageFiles: {
            open: AxiosRequestConfig;
            close: AxiosRequestConfig;
        };
        submit: AxiosRequestConfig;
        storage: {
            get: AxiosRequestConfig;
            save: AxiosRequestConfig;
            delete: AxiosRequestConfig;
        };
        engagement: AxiosRequestConfig;
        vehicles: AxiosRequestConfig;
        primodetails: AxiosRequestConfig;
        consent: AxiosRequestConfig;
        suppliers: AxiosRequestConfig;
        insurance: AxiosRequestConfig;
        scalepoint: {
            ssoEmail: AxiosRequestConfig;
            sso: AxiosRequestConfig;
            basket: AxiosRequestConfig;
        };
        animals: {
            pets: AxiosRequestConfig;
            petClaims: AxiosRequestConfig;
        };
        pingSession: AxiosRequestConfig;
        claimFormApi: {
            formConfig: AxiosRequestConfig;
            pages: AxiosRequestConfig;
        };
        carbucks: {
            timeslots: AxiosRequestConfig;
            reservation: {
                create: AxiosRequestConfig;
                update: AxiosRequestConfig;
            };
            customer: AxiosRequestConfig;
        };
    };
}

/**
 * Interface representing the feature flags for the application.
 */
export interface Features {
    /**
     * Set this feature flag to 'true' to disable the Scalepoint widget/integration in the claim form web application.
     * Customers will see a message indicating that the online items registration is not available at the moment instead of the normal Scalepoint widget.
     */
    isScalepointClosed?: boolean;
}

const ConfigContext = createContext<TopConfig>({} as TopConfig);

export { ConfigContext };
